import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const SidebarCollapsedHover = ({
  type,
  ...rest
}: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <>
        <path
          d='M3 9.4C3 7.15979 3 6.03968 3.43597 5.18404C3.81947 4.43139 4.43139 3.81947 5.18404 3.43597C6.03968 3 7.15979 3 9.4 3H14.6C16.8402 3 17.9603 3 18.816 3.43597C19.5686 3.81947 20.1805 4.43139 20.564 5.18404C21 6.03968 21 7.15979 21 9.4V14.6C21 16.8402 21 17.9603 20.564 18.816C20.1805 19.5686 19.5686 20.1805 18.816 20.564C17.9603 21 16.8402 21 14.6 21H9.4C7.15979 21 6.03968 21 5.18404 20.564C4.43139 20.1805 3.81947 19.5686 3.43597 18.816C3 17.9603 3 16.8402 3 14.6V9.4Z'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M7 3V21'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M14.804 9.69604L12.5 12L14.804 14.304'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </>
    ) : (
      <>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M14.5996 2.25C15.7072 2.25 16.5835 2.24909 17.2881 2.30664C18.0014 2.36492 18.6051 2.48682 19.1562 2.76758C20.05 3.22298 20.777 3.94998 21.2324 4.84375C21.5132 5.39487 21.6351 5.99862 21.6934 6.71192C21.7509 7.41651 21.75 8.29277 21.75 9.40039V14.5996C21.75 15.7072 21.7509 16.5835 21.6934 17.2881C21.6351 18.0014 21.5132 18.6051 21.2324 19.1562C20.777 20.05 20.05 20.777 19.1562 21.2324C18.6051 21.5132 18.0014 21.6351 17.2881 21.6934C16.5835 21.7509 15.7072 21.75 14.5996 21.75H9.40039C8.29277 21.75 7.41651 21.7509 6.71192 21.6934C5.99862 21.6351 5.39487 21.5132 4.84375 21.2324C3.94998 20.777 3.22298 20.05 2.76758 19.1562C2.48682 18.6051 2.36492 18.0014 2.30664 17.2881C2.24909 16.5835 2.25 15.7072 2.25 14.5996V9.40039C2.25 8.29277 2.24909 7.41651 2.30664 6.71192C2.36492 5.99862 2.48682 5.39487 2.76758 4.84375C3.22298 3.94998 3.94998 3.22298 4.84375 2.76758C5.39487 2.48682 5.99862 2.36492 6.71192 2.30664C7.41651 2.24909 8.29277 2.25 9.40039 2.25H14.5996ZM9.40039 3.75C8.75247 3.75 8.21188 3.75102 7.75 3.76074V20.2383C8.21188 20.248 8.75247 20.25 9.40039 20.25H14.5996C15.732 20.25 16.5367 20.2497 17.166 20.1982C17.7866 20.1475 18.1711 20.0506 18.4756 19.8955C19.087 19.5839 19.5839 19.087 19.8955 18.4756C20.0506 18.1711 20.1475 17.7866 20.1982 17.166C20.2497 16.5367 20.25 15.732 20.25 14.5996V9.40039C20.25 8.26798 20.2497 7.46335 20.1982 6.83399C20.1475 6.21336 20.0506 5.82889 19.8955 5.52442C19.5839 4.91305 19.087 4.41605 18.4756 4.10449C18.1711 3.94936 17.7866 3.85247 17.166 3.80176C16.5367 3.75035 15.732 3.75 14.5996 3.75H9.40039Z'
          fill='currentColor'
        />
        <path
          d='M14.2736 9.16576C14.5664 8.87292 15.0412 8.87302 15.3341 9.16576C15.627 9.45866 15.627 9.93342 15.3341 10.2263L13.5597 11.9997L15.3341 13.7742C15.6269 14.0671 15.627 14.5418 15.3341 14.8347C15.0412 15.1272 14.5663 15.1274 14.2736 14.8347L11.9698 12.53C11.6771 12.2371 11.677 11.7623 11.9698 11.4695L14.2736 9.16576Z'
          fill='currentColor'
        />
      </>
    )}
  </IconBase>
);
